export default {"src":"/_next/static/media/WalletAPIDark.a9758fcc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};